import React from 'react'
import { Col, Row } from 'react-grid-system'
import { CommonSlider } from 'components'

import Skeleton from 'react-loading-skeleton'

import styles from './styles.module.css'

const SingleProductSkeleton = () => {
  return (
    <div className={styles.img_container}>
      <Row gutterWidth={16}>
        <Col xs={9}>
          <Skeleton style={{ flex: 1, aspectRatio: '1 / 1' }} />
        </Col>
        <Col xs={3}>
          <div>
            <CommonSlider
              items={[1, 2, 3].map(() => (
                <Skeleton style={{ flex: 1, aspectRatio: '1 / 1' }} />
              ))}
              sliderOptions={{
                direction: 'ttb',
                height: document.querySelector('#featured-image')
                  ? document.querySelector('#featured-image').clientHeight
                  : 300,
                perPage: 3,
                gap: '15px',
              }}
            />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default SingleProductSkeleton
